




















































































import { Component, Mixins, Prop, Emit } from "vue-property-decorator";
import { DomainRegistry } from "../../../domain";
import { DocumentSummary, DocumentSummaryHistory } from "../../../domain/document";
import { Patient } from "../../../domain/patient";
import { IRectangle } from "../../../domain/system";
import {
  RightSidePane,
  ContentHeaderPane,
  NavigationPane,
} from "../../panes";
import { ModelEditableMixin, PdfStyleDrawableMixin } from "../../system/mixins";
import { IGeometryManageable } from "../../system/utilities";
import PdfViewer from "../../system/viewers/PdfViewer.vue";
import DocumentsFinder from "../selectors/DocumentsFinder.vue";
import { IOptionFilterable, ISortParameter } from "../../system";
import Separator from "../../system/Separator.vue";
import { DocumentSummaryEditMenu, IDocumentSummaryEditMenuRestrictions } from "./menus";
import {
  DocumentsSort,
  DocumentSelector,
  DocumentArchiveSelector,
  DocumentArchiveIndicator,
} from "../selectors";
import { DocumentPublishedHistoryViewerDialog } from "./dialogs";

interface IDocumentListViewerGeometry extends IRectangle {
  documentListViewer?: {
    selector: {
      width: number;
    };
  };
}

@Component({
  components: {
    RightSidePane,
    ContentHeaderPane,
    NavigationPane,
    DocumentsFinder,
    DocumentsSort,
    DocumentSelector,
    DocumentArchiveSelector,
    DocumentArchiveIndicator,
    DocumentSummaryEditMenu,
    Separator,
    PdfViewer,
    DocumentPublishedHistoryViewerDialog,
  }
})
export default class DocumentListViewer extends Mixins(ModelEditableMixin, PdfStyleDrawableMixin) implements IGeometryManageable<IDocumentListViewerGeometry>, IOptionFilterable<DocumentSummary> {
  editingSource: DocumentSummary;
  readPropertyOrDefault: <T>(reader: (source: DocumentSummary) => T, defaultValue: T) => T;

  @Prop({ default: null })
  patient: Patient;

  @Prop({ default: false })
  isMenuVisible: boolean;

  @Prop({ default: "" })
  presetFilterKey: string;

  @Prop()
  restrictions: IDocumentSummaryEditMenuRestrictions;

  @Prop({ default: null })
  ignoreDocumentId: number;

  @Prop({ default: false })
  isOtherPatientSelectable: boolean;

  @Prop({ default: true })
  isReady: boolean;

  $refs!: {
    finder: DocumentsFinder;
    selector: DocumentSelector;
    publishedHistoryViewer: DocumentPublishedHistoryViewerDialog;
  };

  data(): any {
    return {
      foundDocuments: [] as DocumentSummary[],
      sortDocuments: [] as DocumentSummary[],
      sortParameter: null,
      isDocumentsFinding: false,
      selectedDocument: null,
      selectorWidth: 800,
      hasPublishedHistory: false,
      shouldShowListOptionsOnly: false,
    };
  }
  foundDocuments: DocumentSummary[];
  sortDocuments: DocumentSummary[];
  sortParameter: ISortParameter;
  isDocumentsFinding: boolean;
  selectedDocument: DocumentSummaryHistory;
  selectorWidth: number;
  hasPublishedHistory: boolean;
  shouldShowListOptionsOnly: boolean;

  public filteredText: string = "";

  get selectedDocumentId(): number {
    return this.readPropertyOrDefault(s => s.id, null);
  }

  get editingDocument(): DocumentSummary {
    return this.editingSource;
  }

  set editingDocument(value: DocumentSummary) {
    this.editingSource = value;
    this.find();
  }

  get isPatientSelectable(): boolean {
    return !!this.patient;
  }

  get selectedHistory(): DocumentSummaryHistory {
    return (this.selectedDocument && !this.selectedDocument.isLatest)
      ? this.selectedDocument
      : null;
  }

  get isReadableDocumentSelected(): boolean {
    return this.readPropertyOrDefault(s => s.isReadable, false);
  }

  get previewSrc(): string {
    return this.selectedDocument
      ? this.selectedDocument.previewSource.source
      : (this.isMenuVisible ? null : this.readPropertyOrDefault(s => s.previewSource.source, ""));
  }

  get isSelectedDocumentUnmanaged(): boolean {
    // previewSrcの実装に合わせたが...複雑すぎる.文書一覧と文書作成タブで処理を変えるためのようだが...
    // TODO: リファクタ.
    const document = this.selectedDocument ? this.selectedDocument : this.isMenuVisible ? null : this.editingDocument;
    return document && document.isUnmanaged;
  }

  get shouldRenderDocumentPdfByPlugin(): boolean {
    return this.$configuration.behavior.document.viewer.pdfRendering.shouldRenderUnmanagedDocumentByPlugin && this.isSelectedDocumentUnmanaged;
  }

  get isPreviewPdfLikeEditingEnable(): boolean {
    return this.selectedDocument && !this.selectedDocument.isUnmanaged && !this.selectedDocument.isVirtual;
  }

  get isPublishedHistoryEnable(): boolean {
    return !!this.selectedDocument && this.hasPublishedHistory;
  }

  get filteredOptions(): DocumentSummary[] {
    return this.sortDocuments;
  }

  created(): void {
    this.$registerGeometryManager(this);
  }

  destroyed(): void {
    this.$unregisterGeometryManager(this);
  }

  getGeometryNames(isWindowRectangleHandleable: boolean): string[] {
    return [
      "ペイン幅",
    ];
  }

  storeGeomerty(source: IDocumentListViewerGeometry, isWindowRectangleHandleable: boolean): void {
    source.documentListViewer = {
      selector: {
        width: this.selectorWidth,
      },
    };
  }

  restoreGeomerty(source: IDocumentListViewerGeometry, isWindowRectangleHandleable: boolean): void {
    if (!source.documentListViewer) {
      return;
    }
    this.selectorWidth = source.documentListViewer.selector.width;
  }

  find() {
    (this.$refs.finder as DocumentsFinder).find();
  }

  clear() {
    (this.$refs.finder as DocumentsFinder).clear();
  }

  resetInfiniteLoading() {
    (this.$refs.selector as DocumentSelector).resetInfiniteLoading();
  }

  // finder から結果がEmitされる
  searchCompleted(documents: DocumentSummary[], conditions: string): void {
    // 編集中文書は非表示
    this.foundDocuments = this.ignoreDocumentId
      ? documents.filter((v) => v.id !== this.ignoreDocumentId)
      : documents;
    this.filteredText = conditions;
  }

  updateDocumentsFinding(isFinding: boolean): void {
    this.isDocumentsFinding = isFinding;
    this.editingSource = null;
  }

  onSortChanged(param: ISortParameter): void {
    this.sortParameter = param;
  }

  onPublishedHistoryUpdated(hasPublishedHistory: boolean): void {
    this.hasPublishedHistory = hasPublishedHistory;
  }

  onDimensionalSortStarted() {
    this.$refs.selector.clearSort();
  }

  updateShouldShowListOptionsOnly(value: boolean) {
    this.shouldShowListOptionsOnly = value;
  }

  @Emit("documentDoubleClick")
  documentDoubleClick(summary: DocumentSummary, archiveId: number): void {}

  onDocumentDoubleClicked(): void {
    if (!this.isDocumentReadable) {
      return;
    }
    this.documentDoubleClick(this.editingSource, this.archiveId);
  }

  get isDocumentReadable(): boolean {
    return this.readPropertyOrDefault(s => s.isReadable, false);
  }

  get archiveId(): number {
    return this.selectedHistory
      ? this.selectedHistory.archiveId
      : null;
  }

  get documentId(): number {
    return this.readPropertyOrDefault(s => s.id, undefined);
  }

  get patientId(): string {
    return this.readPropertyOrDefault(s => s.patientNo, undefined);
  }

  get isPreviewableLikeEditing(): boolean {
    return this.$configuration.behavior.document.list.menu.previewLikeEditing.isEnable;
  }

  async showPreviewPdfLikeEditing(): Promise<void> {
    const repository = DomainRegistry.document.getDocumentRepository();
    const source = await repository.createPreviewLikeEditingSource(this.selectedDocument.id, this.selectedDocument.patientNo, this.selectedDocument.edition);
    const param: any = {
      name: this.selectedDocument.documentName,
      encodedUri: encodeURIComponent(source.source),
    };
    return this.$openWindow("/ShowDocumentSimply", param);
  }

  async showPublishedHistory(): Promise<void> {
    await this.$refs.publishedHistoryViewer.show(this.documentId);
  }
}
